/*
 * Public API Surface of aumico notes
 */

export {
    getNotesTemplateById,
    onCreateNotesTemplateFailed,
    onCreateNotesTemplateSuccessfully,
} from './actions/notesTemplates.actions';
export {
    onUpdateTranslationsFailed,
    onUpdateTranslationsSuccess,
    updateTranslations,
} from './actions/translations.actions';
export * from './aumico-notes.config';
export * from './aumico-notes.module';
export * from './components/component-print-preview-deprecated/component-print-preview-deprecated.component';
export * from './components/componentOptions/IComponentOptionsDelegate';
export * from './components/componentOptions/componentOptions.component';
export * from './components/equity/IEquityDelegate.interface';
export * from './components/equity/equity.component';
export * from './components/fli/IFliDelegate.component';
export * from './components/fli/fli.component';
export * from './components/freeTableWithAmounts/IFreeTableDelegate.interface';
export * from './components/freeTableWithAmounts/freeTableWithAmounts.component';
// exported components to be used as type

export { EditNotesTypesTranslationsComponent } from './components/edit-notes-types-translations/edit-notes-types-translations.component';
export * from './components/movement-schedule/movement-schedule-table/movement-schedule-table.component';
export * from './components/movement-schedule/movement-schedule.component';
export * from './components/notes-component-display/notes-component-display.component';
export * from './components/notes-components-list/INotesComponentsListDelegation.interface';
export * from './components/notes-components-list/notes-components-list.component';
export * from './components/notes-display/notes-german-display/notes-german-display.component';
export * from './components/notesTemplatePreview/notesTemplatePreview.component';
export * from './components/preview/preview.component';
export * from './components/print-preview/movement-schedule/movement-schedule-print-preview-deprecated.component';
export * from './components/print-preview/movement-schedule/movement-schedule-table-print-preview-deprecated/movement-schedule-print-preview-table-deprecated.component';
export * from './components/richText/IRichTextDelegate.interface';
export * from './components/richText/richText.component';
export * from './components/select/ISelectDelegate.interface';
export * from './components/select/select.component';
export * from './components/tableWithForm/tableWithForm.component';
export { Errors } from './enums/errors.enum';
export * from './enums/movementScheduleColumnIndexes.enum';
export * from './helpers/movementSchedule.helper';
export { NotesEmptyLinesRemovalHelper } from './helpers/notesEmptyLinesRemoval.helper';
export { NotesTemplatesHelper } from './helpers/notesTemplates.helper';
export * from './helpers/super-table.helper';
export { IAnnualReportAccordionsData } from './interfaces/IAnnualReportAccordionsData.interface';
export * from './interfaces/IAnnualReportDefaultSettings.interface';
export * from './interfaces/IComponentOptionsDialogProperties.interface';
export * from './interfaces/IComponentOptionsProperties.interface';
export * from './interfaces/IFLIForNotes.interface';
export * from './interfaces/IFliTotalRow.interface';
export * from './interfaces/IFxNotesContext.interface';
export * from './interfaces/fx-print-row.interface';
export * from './interfaces/IKeyName.interface';
export * from './interfaces/ILegalFormAndAccountBasis.interface';
export * from './interfaces/ILegalFormAndAccountBasisCombinationCheck.interface';
export * from './interfaces/IMovmentScheduleFliForNotes.interface';
export * from './interfaces/INameExistenceFiltration.interface';
export * from './interfaces/movement-schedule/IMovementScheduleComponentDelegation.interface';
export * from './interfaces/requests/INotesTemplateByLegalFormAndAccountBasisRequest.interface';
export * from './pages/notes/INotesDelegate.interface';
export * from './pages/notes/notes.page';
export * from './pages/notesTemplates/notes-templates-form/INotesTemplatesFormDelegation.interface';
export * from './pages/notesTemplates/notes-templates-form/notes-templates-form.page';
export * from './pages/notesTemplates/notes-templates-list/INotesTemplatesListDelegate.interface';
export * from './pages/notesTemplates/notes-templates-list/notes-templates-list.page';
export * from './pages/notesTypes/notes-types-form/INotesTypesFormDelegate.interface';
export * from './pages/notesTypes/notes-types-form/notes-types-form.page';
export * from './pages/notesTypes/notes-types-list/INotesTypesListDelegate.interface';
export * from './pages/notesTypes/notes-types-list/notes-types-list.page';
export * from './provider/notes.provider';
export * from './provider/notes.provider.interface';
export * from './reducers/notes.reducer';
export * from './services/notes.service';
export { INotesComponentsNumberedTitles } from './interfaces/notes-numbered-titles.interface';
